import { FrameChrome } from "./FrameChrome";

interface SystemFrameNodeData {
  label: string;
  subtitle?: string;
  [key: string]: unknown;
}

// L2/L3 outer boundary. Wraps the entire architecture (one per L2/L3
// view). Visual contract lives in FrameChrome — this component owns
// only the system tokens and the dashed border style (system frame is
// the standalone outermost frame, so dashed per the
// nested-vs-standalone rule).
//
// Spec: docs/superpowers/specs/2026-05-25-archviz-cluster-framing-design.md

export function SystemFrameNode({ data }: { data: SystemFrameNodeData }) {
  return (
    <FrameChrome
      label={data.label}
      subtitle={data.subtitle}
      fillVar="--cluster-system-fill"
      borderVar="--cluster-system-border"
      borderStyle="dashed"
    />
  );
}
